import { ProcRightLogoSymbol } from "@/shared/constants/images/logo";

export default function LogoSymbol({
  width,
  height,
}: {
  width?: number;
  height?: number;
}) {
  return (
    <img
      src={ProcRightLogoSymbol}
      alt="logo"
      className="logosymbol"
      style={{ width: width || "20px", height: height || "20px" }}
    />
  );
}
